import { render, staticRenderFns } from "./FooterBasket.vue?vue&type=template&id=13c98ea9"
import script from "./FooterBasket.vue?vue&type=script&lang=js"
export * from "./FooterBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports